import React from 'react'
import classnames from 'classnames'
import selectFormat from '../selectFormat'

export default function ClientCount(props){

  let metrics = [

  ]

  return(
    <div className="col-12 d-flex flex-wrap align-items-center">
      {
        metrics.filter( metric => metric.visible == true ).map( (metric, index) => {
          return selectFormat(metric, index)
        })
      }
    </div>
  )
}